import { WorkflowsState } from '../types'
import { WorkflowLoadMode, WorkflowResultsTabs, WorkflowsExecutionStatus } from '../enums'

export const name = 'workflows'

export const initialState: WorkflowsState = {
  loadMode: WorkflowLoadMode.Editor,
  workflow: null,
  toolboxLoaded: false,
  isLoading: false,
  isAutoSaving: false,
  selectedId: null,
  selectedTab: WorkflowResultsTabs.Messages,
  crossHair: null,
  importedFiles: [],
  isSideBarLeftOpen: true,
  isResultsPanelOpen: true,
  isResultsPanelPermanentOpen: false,
  isResultsPanelFullScreen: false,
  creatingDemoWorkflowsIds: [],
  status: {
    state: WorkflowsExecutionStatus.Unexecuted,
    nodes: [],
    executedQuery: undefined,
    startTime: undefined,
    executionStartTime: undefined
  },
  meta: { rowsPerPage: {} },
  log: [],
  messages: [],
  schemas: {},
  toolbox: {
    components: {}
  },
  schedule: null,
  canUndo: false,
  canRedo: false
}
